import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import breakpoint from "@shared/styles/breakpoints";
import FormLogoHeader from "@ats/src/views/sessions/components/FormLogoHeader";
import AuthForm from "@ats/src/views/sessions/components/AuthForm";
import Banner from "@ats/src/components/shared/Banner";
import Carousel from "@shared/components/Carousel";
import SlideCard from "@shared/components/SlideCard";
import Icon from "@ats/src/components/shared/Icon";
import NewHeaderBar from "@ats/src/views/sessions/components/NewHeaderBar";
import HeaderBar from "@ats/src/views/sessions/components/HeaderBar";
import AdRollScript from "@ats/src/components/shared/AdRollScript";

function AuthRegister(props) {
  const errorParam = queryString.parse(location.search).error;
  // const messageParam = queryString.parse(props.location.search).message;
  // const emailParam = queryString.parse(props.location.search).email;
  const inviteToken = queryString.parse(location.search).invite_token;
  const accountDeleted = queryString.parse(props.location.search).account_deleted;
  const [emailConfirmed, setEmailConfirmed] = React.useState(false);

  const carouselItems = [
    <SlideCard
      key="slide1"
      quote="Beautifully simple. Incredibly easy to use but can be customized to your hiring workflow and needs."
      profilePicture="https://inflow-public.s3.us-east-1.amazonaws.com/visibleQuoteHeadshot.webp"
      name="Mike Preuss"
      title="Co-founder and CEO"
      companyName="Visible.vc"
    />,
    <SlideCard
      key="slide2"
      quote="The easiest, fastest, elegant-est hiring workflow solution I've ever used. Everything we needed and nothing we didn't. Perfect."
      profilePicture="https://inflow-public.s3.us-east-1.amazonaws.com/bodeswellQuoteHeadshot.webp"
      name="Matthew Bellows"
      title="CEO"
      companyName="BodesWell.io"
    />,
    <SlideCard
      key="slide3"
      quote="Polymer has transformed our hiring process. We have been able to scale our headcount 70% in the past year, and Polymer has been a huge enabler for us!"
      profilePicture="https://inflow-public.s3.us-east-1.amazonaws.com/gojilabsQuotetHeadshot.webp"
      name="George Gearhart"
      title="COO"
      companyName="Goji Labs"
    />,
  ];

  React.useEffect(() => {
    showEmailConfirmationBannerIfApplicable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showEmailConfirmationBannerIfApplicable = () => {
    let emailConfirmedParam = queryString.parse(props.location.search).email_confirmed;

    if (emailConfirmedParam != undefined) {
      const emailConfirmed = emailConfirmedParam === "true";
      setEmailConfirmed(emailConfirmed);
    }
  };

  const onComplete = ({ email, needsEmailConfirmation, acceptedAnInvite }) => {
    window.logger("%c[Auth] onComplete Auth - Regular Magic Link", "color: #1976D2", {
      acceptedAnInvite,
      email,
      needsEmailConfirmation,
    });

    if (needsEmailConfirmation) {
      props.history.push("/needs-email-confirmation");
    }
    // else if (acceptedAnInvite) {
    //   window.logger("%c[Auth] onComplete Auth - ACCEPTED AN INVITE", "color: #1976D2", {
    //     acceptedAnInvite,
    //   });
    //   props.history.push("/jobs");
    // }
    else {
      const params = new URLSearchParams({ e: btoa(email) });
      props.history.push(`/verify-email?${params.toString()}`);
    }
  };

  return (
    <Local.Container>
      {emailConfirmed ? (
        <Banner message="Email address confirmed. Log in to continue." subtle />
      ) : errorParam === "expired_link" ? (
        <Banner message="Expired. Please try again." subtle />
      ) : errorParam === "invalid_invite" ? (
        <Banner message="Invitation no longer valid." subtle />
      ) : inviteToken != undefined ? (
        <Banner message="Accept your invitation." subtle />
      ) : accountDeleted === "success" ? (
        <Banner message="Your account was successfully deleted." subtle />
      ) : null}

      <Local.RegistrationContainer>
        <Local.RegistrationQuotesColumn>
          <Local.CarouselWrapper>
            <Carousel items={carouselItems} autoplayDelay={6000} />
          </Local.CarouselWrapper>
        </Local.RegistrationQuotesColumn>
        <Local.RegistrationFormColumn>
          <Local.MobileHeader>
            <NewHeaderBar variant="gradient" />
          </Local.MobileHeader>
          <Local.DesktopHeader>
            <HeaderBar darkModeAllowed={false} />
          </Local.DesktopHeader>
          <Local.FormContent>
            <Local.Form>
              <Helmet title="Auth Register" />
              <AdRollScript />
              
              <FormLogoHeader />
              <h2>{inviteToken == undefined ? "Join Polymer today" : "Accept invitation"}</h2>
              <Local.FeaturesRow>
                <Local.FeatureItem>
                  <Icon name="check-circle" />
                  <span>14-day free trial</span>
                </Local.FeatureItem>
                <Local.FeatureItem>
                  <Icon name="check-circle" />
                  <span>No commitment required</span>
                </Local.FeatureItem>
              </Local.FeaturesRow>
              <div>
                <AuthForm
                  onComplete={onComplete}
                  location={props.location}
                  inviteToken={inviteToken}
                  darkModeAllowed={false}
                />
              </div>
            </Local.Form>
            <Local.Links>
              <Link to="/auth">Already have an account?</Link>
              {/* <Link to="/request-password-reset">Forgot your password?</Link> */}
            </Local.Links>
          </Local.FormContent>
          <Local.Recaptcha>
            <p>
              This site is protected by reCAPTCHA and the Google{" "}
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and{" "}
              <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </p>
          </Local.Recaptcha>
        </Local.RegistrationFormColumn>

      </Local.RegistrationContainer>
    </Local.Container>
  );
}

export default withRouter(AuthRegister);

/* Local styled wrappers for responsive headers */
const Local: any = {};

Local.MobileHeader = styled.div(() => {
  return css`
    label: AuthRegister_MobileHeader;
    display: block;
    ${breakpoint.lg} {
      display: none;
    }
  `;
});

Local.DesktopHeader = styled.div(() => {
  return css`
    label: AuthRegister_DesktopHeader;
    display: none;
    ${breakpoint.lg} {
      display: block;
    }
  `;
});

/* Registration-specific styled components moved from global Styled.tsx */
Local.RegistrationContainer = styled.div(() => {
  return css`
    label: Session_RegistrationContainer;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: flex-start;

    ${breakpoint.xs} {
      align-items: center;
    }
  `;
});

Local.RegistrationFormColumn = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_RegistrationFormColumn;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background-color: ${t.color.white};

    ${breakpoint.lg} {
      width: 50%;
    }
  `;
});

Local.RegistrationQuotesColumn = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_RegistrationQuotesColumn;
    display: none;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: ${t.color.black};

    ${breakpoint.lg} {
      display: flex;
    }
  `;
});

Local.CarouselWrapper = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_CarouselWrapper;
    width: 80%;
    max-width: 490px;
    padding-bottom: ${t.spacing[8]};

    ${t.mq["md"]} {
      width: 100%;
    }
  `;
});

Local.FeaturesRow = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_FeaturesRow;
    display: flex;
    justify-content: space-between;
    width: 100%;
    ${[t.px(3)]}

    &:first-of-type {
      ${[t.mr(2)]}
    }
  `;
});

Local.FeatureItem = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_FeatureItem;
    display: flex;
    ${[t.text.xs]};
    align-items: center;
    color: ${t.color.gray[600]};

    svg {
      width: 14px;
      height: 14px;
      margin-right: 4px;
      color: ${t.color.gray[600]};
    }
  `;
});

Local.FormContent = styled.div((props: any) => {
  const t = props.theme;
  return css`
    label: Session_FormContent;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    width: 100%;
    margin-top: 0;
    background-color: ${t.color.white};

    ${breakpoint.xs} {
      justify-content: center;
      margin-top: 44px;
    }
  `;
});

/* Local versions of Styled components with t.dark conditionals to disallow darkmode on auth-register*/
Local.Container = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow-x: auto;
    background-color: ${t.color.white};

    ${breakpoint.lg} {
      background-color: ${t.color.black};
    }
  `;
});

Local.Form = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_Form;
    ${[t.py(8), t.px(4), t.rounded.md]}

    max-width: 427px;
    width: 100%;
    border: 1px solid transparent;
    background-color: ${t.color.white};
    h2 {
      font-size: 2.25rem;
      font-weight: 700;
      letter-spacing: 0.5px;
      ${[t.mb(3)]};
      color: ${t.color.black};
      text-align: center;
    }

    ul {
      ${[t.mt(8)]}
    }

    ${breakpoint.xxs} {
      ${[t.px(8)]}
    }

    ${breakpoint.xs} {
      border: 1px solid ${t.color.gray[200]};
      background-color: ${t.color.white};
    }
  `;
});

Local.Links = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: Session_Links;
    ${[t.text.xs, t.mt(0), t.pl(0)]}
    color: ${t.color.gray[600]};
    width: 100%;
    max-width: 427px;
    display: flex;
    justify-content: space-between;
    margin-top: -12px;
    background-color: ${t.color.white};
    button,
    a {
      ${[t.py(2), t.pr(0), t.pl(4), t.text.normal]}
      color: ${t.color.gray[600]};
      background: none;
      border: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    button:first-child,
    a:first-child {
      ${[t.pl(4)]}
    }

    button:last-child,
    a:last-child {
      ${[t.pr(4)]}
    }

    ${breakpoint.xxs} {
      button,
      a {
        ${[t.px(0)]}
      }

      button:first-child,
      a:first-child {
        ${[t.pl(8)]}
      }

      button:last-child,
      a:last-child {
        ${[t.pr(8)]}
      }
    }

    ${breakpoint.xs} {
      ${[t.px(0), t.mt(4)]}

      button,
      a {
        ${[t.px(1)]}
      }

      button:first-child,
      a:first-child {
        ${[t.pl(0)]}
      }

      button:last-child,
      a:last-child {
        ${[t.pr(0)]}
      }
    }
  `;
});

Local.Recaptcha = styled.div((props: any) => {
  const t: any = props.theme;
  return css`
    label: Auth_RecaptchaStatement;
    width: 100%;
    position: relative;
    bottom: 0;
    display: flex;
    justify-content: center;
    background-color: ${t.color.white};
    ${[t.h(14), t.pt(8)]}


    p {
      max-width: 327px;
      ${[t.text.xs, t.h(9), t.mb(1), t.px(4)]}
      line-height: 1.2;
      text-align: center;
      color: ${t.color.gray[600]};
      a:hover {
        color: ${t.color.black};
      }
    }
    ${breakpoint.xxs} {
      p {
        line-height: 1.5;
        ${[t.mb(4)]}
      }
    }
  `;
});
